// Hero feed: notifications float in, live for a while and give way to the next one,
// somewhere else. Four on screen at most, in fixed slots that never cover the copy
// or each other.
import { $, $$, G, fine, shuffle } from './misc'

const WA = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.3-.3.6-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l2 .9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>'
const MAIL = '<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" d="M3 6h18v12H3zM3 7l9 6 9-6"/></svg>'
const IC = {
  ai: '<i class="i-ai"><svg><use href="#i-spark"/></svg></i>',
  ok: '<i class="i-ok"><svg viewBox="0 0 363 364" fill="currentColor"><use href="#mk-v"/></svg></i>',
  wa: `<i class="i-wa">${WA}</i>`,
  cash: '<i class="i-cash">$</i>',
  mail: `<i class="i-mail">${MAIL}</i>`,
  car: '<i class="i-blue"><svg><use href="#i-car"/></svg></i>',
  home: '<i class="i-blue"><svg><use href="#i-home"/></svg></i>',
  heart: '<i class="i-mail"><svg><use href="#i-heart"/></svg></i>',
  pct: '<i class="i-blue i-big">%</i>',
}
type Icon = keyof typeof IC
// [icon, title or label, value or subtitle, hover detail, numeric?]
type Entry = [Icon | null, string, string | (() => string), string, boolean?]
const FEED: Entry[] = [
  ['ai', 'Póliza cargada con IA', 'en 6 segundos, desde el PDF', 'Martina Ruiz · Automotores · 12 cuotas'],
  [null, 'Mejor precio entre 32 compañías', () => document.documentElement.dataset.best || '$ 39.540', 'Todo riesgo · 23% debajo del promedio', true],
  [null, 'Comisiones recuperadas este mes', '$ 184.320', '11 diferencias en 3 liquidaciones', true],
  ['wa', 'Agente IA de WhatsApp', 'respondió a las 23:47', 'Le mandó la póliza a Martina'],
  ['ok', '23 renovaciones avisadas', 'esta semana', 'Por mail y WhatsApp, sin tocar nada'],
  ['cash', 'Cobrado hoy', '$ 718.560', '16 cuotas · 3 rendiciones listas', true],
  ['car', 'Póliza emitida', 'Toyota Corolla · Todo riesgo', 'Fotos e inspección aprobadas'],
  ['mail', 'Campaña enviada', '1.248 clientes · 812 abrieron', 'Renovaciones de noviembre'],
  ['home', 'Hogar cotizado', '12 compañías en 9 segundos', 'La más barata: $ 18.420 por mes'],
  ['ai', 'El Asesor IA te avisa', '3 cuotas vencidas hoy', 'Lucía, Carlos y Ana · $ 134.730'],
  ['cash', 'Comisiones liquidadas', '$ 2.413.900', 'Octubre · 9 compañías conciliadas', true],
  ['ok', 'Cartera importada', '4.812 pólizas de 6 compañías', 'Sin cargar nada a mano'],
  ['heart', 'Vida renovada', 'Carlos Díaz · +8% de suma', 'Aviso enviado por WhatsApp'],
  ['wa', 'Siniestro iniciado por WhatsApp', 'Ana Torres · 02:14', 'Denuncia cargada con fotos'],
  ['ai', '¿Qué vence esta semana?', '23 pólizas · $ 1.240.300', 'Respuesta del Asesor IA en 2 segundos'],
  ['pct', 'Retención de cartera', '91%', '+3 puntos contra el año pasado', true],
  ['ok', 'Recibo emitido', 'Cuota 6 de 12 · Hogar', 'Enviado a Lucía Gómez por mail'],
  ['mail', 'Documentación enviada', 'Póliza y cuponera a Martina', 'Desde tu dominio verificado'],
]
// [right %, top svh]
const SLOTS: [number, number][] = [[14, 14], [36, 30], [3, 40], [31, 60], [3, 74], [19, 87], [30, 12], [22, 44], [36, 78]]
const WHEN = ['ahora', 'hace 1 min', 'hace 2 min', 'hace 4 min']
const VISIBLE = 4
const EVERY_MS = 2600

interface Card { f: HTMLElement; slot: number; bob?: gsap.core.Tween }

export interface Feed { start(): void }

export function createFeed(): Feed | null {
  const feedBox = $('.floats')
  if (!feedBox) return null
  const live: Card[] = []
  let order = shuffle(FEED.map((_, i) => i)); let next = 0

  // Hover tilt with a glare that follows the pointer.
  const tilt = (f: HTMLElement, inn: HTMLElement) => {
    f.addEventListener('pointermove', (e) => {
      const r = inn.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width; const py = (e.clientY - r.top) / r.height
      inn.style.setProperty('--ry', `${(px - 0.5) * 18}deg`); inn.style.setProperty('--rx', `${(0.5 - py) * 14}deg`)
      inn.style.setProperty('--mx', `${px * 100}%`); inn.style.setProperty('--my', `${py * 100}%`)
    })
    f.addEventListener('pointerleave', () => { inn.style.setProperty('--rx', '0deg'); inn.style.setProperty('--ry', '0deg') })
  }
  const build = (n: number) => {
    const [ic, t, v, fx, num] = FEED[n]
    const val = typeof v === 'function' ? v() : v
    const f = document.createElement('div'); f.className = 'fc'
    f.innerHTML = `<div class="fc-in">${ic ? IC[ic] : ''}<span>${num ? `<span class="k">${t}</span><b class="mono">${val}</b>` : `<b>${t}</b>${val}`}<em class="fx">${fx}</em></span><small class="when">${WHEN[Math.floor(Math.random() * WHEN.length)]}</small></div>`
    f.dataset.depth = String(18 + Math.round(Math.random() * 28))
    tilt(f, $('.fc-in', f)!)
    return f
  }
  const spawn = (avoid = -1) => {
    const used = live.map((c) => c.slot)
    const free = SLOTS.map((_, i) => i).filter((i) => !used.includes(i) && i !== avoid)
    if (!free.length) return
    const f = build(order[next]); next = (next + 1) % order.length
    if (next === 0) order = shuffle(order)
    f.style.visibility = 'hidden'
    feedBox.appendChild(f)
    // Try the free slots in random order; keep the first where the card touches neither the copy nor another card.
    // Margin covers the bob (10px) and the pointer parallax (up to ~23px).
    const pad = 34
    const hit = (a: DOMRect, b: DOMRect) => !(a.right + pad <= b.left || b.right + pad <= a.left || a.bottom + pad <= b.top || b.bottom + pad <= a.top)
    const blockers = [...$$('.hero .pill, .hero .kick, .hero .h-hero .w, .hero .rot, .hero .lead, .hero .ctas > *, .hero-stats li'), ...live.map((c) => $('.fc-in', c.f)!)].map((e) => e.getBoundingClientRect())
    let slot = -1
    for (const s of shuffle(free)) {
      f.style.right = `${SLOTS[s][0]}%`; f.style.top = `${SLOTS[s][1]}svh`
      const r = $('.fc-in', f)!.getBoundingClientRect()
      if (r.left >= 8 && r.right <= innerWidth - 8 && !blockers.some((b) => hit(r, b))) { slot = s; break }
    }
    if (slot < 0) { f.remove(); return }
    f.style.visibility = ''
    const c: Card = { f, slot }
    live.push(c)
    f.classList.add('ping')
    G.fromTo(f, { opacity: 0, scale: 0.82, y: 26, filter: 'blur(8px)' }, {
      opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 0.75, ease: 'back.out(1.6)',
      onComplete: () => { c.bob = G.to(f, { y: Math.random() < 0.5 ? 10 : -10, duration: 2.6 + Math.random() * 1.4, ease: 'sine.inOut', yoyo: true, repeat: -1 }) },
    })
  }
  // The oldest card that is not under the pointer leaves; a hovered card stays.
  const retire = () => {
    const i = live.findIndex((c) => !c.f.matches(':hover'))
    if (i < 0) return -1
    const [c] = live.splice(i, 1)
    if (c.bob) c.bob.kill()
    G.to(c.f, { opacity: 0, scale: 0.9, y: '-=18', filter: 'blur(6px)', duration: 0.5, ease: 'power2.in', onComplete: () => c.f.remove() })
    return c.slot
  }
  // Paused off the hero, in a hidden tab, and where the CSS hides the feed (narrow screens).
  const feedOn = () => !document.hidden && scrollY < innerHeight * 0.6 && getComputedStyle(feedBox).display !== 'none'

  if (fine()) {
    addEventListener('pointermove', (e) => {
      const mx = e.clientX / innerWidth - 0.5; const my = e.clientY / innerHeight - 0.5
      live.forEach(({ f }) => { const dp = Number(f.dataset.depth); f.style.translate = `${-mx * dp}px ${-my * dp}px` })
    })
  }

  let started = false
  return {
    start() {
      if (started) return
      started = true
      // Every spawn re-checks feedOn(): the visitor may have scrolled away or hidden the tab meanwhile.
      for (let k = 0; k < VISIBLE; k++) G.delayedCall(k * 0.35, () => { if (feedOn()) spawn() })
      setInterval(() => {
        if (!feedOn() || live.length < VISIBLE) { if (feedOn() && live.length < VISIBLE) spawn(); return }
        const freed = retire()
        if (freed >= 0) G.delayedCall(0.45, () => { if (feedOn()) spawn(freed) })
      }, EVERY_MS)
    },
  }
}
